/**
 * @generated SignedSource<<edd1240caec872c20359af540fdbb38b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbPricingGuidance_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbPricingGuidance_viewer";
};
export type PdpRespSidebarBlurbPricingGuidance_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbPricingGuidance_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbPricingGuidance_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbPricingGuidance_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceHelpers_viewer",
      "selections": [
        {
          "alias": "pdpSiderailSoldPricingGuidanceLinkFF",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "pdpSiderailSoldPricingGuidanceLink"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"pdpSiderailSoldPricingGuidanceLink\")"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f4b0e660775b3a5c51ed5abf7d69d0c6";

export default node;
